import React from 'react'
import Component_Heading from '../component/Component_Heading'
import { Link } from 'react-router-dom';
import './css/services.css'

export default function Web_Dev_Services(props) {
  return (
    <>
      

        <div className="container web-ser1">
            <div className="row row-cols-3 web-ser-row">
                <div className="col web-ser-col">
                <div className="circle-container">
                    <div className="main-web-ser">
                        <div className="web-ser-heading">
                            <h1>{props.head1}</h1>
                        </div>
                        <div className="web-ser-para">
                            <p>{props.para1}</p>
                        </div>
                        <div className="wer-ser-link">
                        <Link className="nav-link active" aria-current="page" to="/rajdigi">Explore Now +</Link>
                        </div>
                    </div>
                </div>
                </div>
                <div className="col web-ser-col">
                <div className="circle-container">
                    <div className="main-web-ser">
                        <div className="web-ser-heading">
                            <h1>{props.head2}</h1>
                        </div>
                        <div className="web-ser-para">
                            <p>{props.para2}</p>
                        </div>
                        <div className="wer-ser-link">
                        <Link className="nav-link active" aria-current="page" to="/rajdigi">Explore Now +</Link>
                        </div>
                    </div>
                </div>
                </div>
                <div className="col web-ser-col">
                <div className="circle-container">
                    <div className="main-web-ser">
                        <div className="web-ser-heading">
                            <h1>{props.head3}</h1>
                        </div>
                        <div className="web-ser-para">
                            <p>{props.para3}</p>
                        </div>
                        <div className="wer-ser-link">
                        <Link className="nav-link active" aria-current="page" to="/rajdigi">Explore Now +</Link>
                        </div>
                    </div>
                </div>
                </div>
                
                </div>
                </div>
                
                <div className="container web-ser">
            <div className="row row-cols-3 web-ser-row">
                <div className="col web-ser-col">
                <div className="circle-container">
                    <div className="main-web-ser">
                        <div className="web-ser-heading">
                            <h1>{props.head4}</h1>
                        </div>
                        <div className="web-ser-para">
                            <p>{props.para4}</p>
                        </div>
                        <div className="wer-ser-link">
                        <Link className="nav-link active" aria-current="page" to="/rajdigi">Explore Now +</Link>
                        </div>
                    </div>
                </div>
                </div>
                <div className="col web-ser-col">
                <div className="circle-container">
                    <div className="main-web-ser">
                        <div className="web-ser-heading">
                            <h1>{props.head5}</h1>
                        </div>
                        <div className="web-ser-para">
                            <p>{props.para5}</p>
                        </div>
                        <div className="wer-ser-link">
                        <Link className="nav-link active" aria-current="page" to="/rajdigi">Explore Now +</Link>
                        </div>
                    </div>
                </div>
                </div>
                <div className="col web-ser-col">
                <div className="circle-container">
                    <div className="main-web-ser">
                        <div className="web-ser-heading">
                            <h1>{props.head6}</h1>
                        </div>
                        <div className="web-ser-para">
                            <p>{props.para6}</p>
                        </div>
                        <div className="wer-ser-link">
                        <Link className="nav-link active" aria-current="page" to="/rajdigi">Explore Now +</Link>
                        </div>
                    </div>
                </div>
                </div>
                
                </div>
                </div>

    </>
  )
}
